import * as React from 'react';
import { useEffect } from 'react';
import { AdTakeover } from '@sch-inventory/ad-takeover/dist/ad-takeover';
import { useShowTag } from '../hooks/ad';

type Props = {
    id: string;
    targetId: string;
    className?: string;
    proximity?: number;
};

export function Takeover(props: Props) {
    const {
        targetId,
        className = 'ads__unit ads__unit--banner ads__unit--fullwidth',
        proximity = 100,
    } = props;
    useShowTag(targetId, proximity);
    useEffect(() => {
        if (document) {
            try {
                const width = Math.max(
                    document.documentElement.clientWidth,
                    window.innerWidth || 0,
                );

                if (window.apntag) {
                    AdTakeover.create(
                        targetId,
                        {
                            articlesContainerWidth: width,
                            headerSelector: '.top-bar',
                        },
                        window.apntag,
                    );
                }
            } catch (ex) {
                console.error(ex);
            }
            document.body.classList.add('mobile', 'has-ad-takeover');
        }

        return function cleanup() {
            if (document) {
                document.body.classList.remove('mobile', 'has-ad-takeover');
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // We only want this to run once

    return (
        <div id={targetId} className={className}>
            <span className="ad-info-wrap">
                <div id={`${targetId}-button`} className="ad-info" />
            </span>
        </div>
    );
}
